import React, { PropTypes, Component } from 'react';

import 'styles/about.scss';

class About extends Component {
    render () {
        return (
            <div className="section about">
              <div className="container">
                <div className="header">
                  <h2>About Dr. Kiandra Hebert</h2>
                </div>
                <div className="body">
                  <p>
                    Kiandra is a licensed clinical psychologist specializing in
                    treating anxiety, depression, and relationship difficulties.
                    She earned her Ph.D. from UCSD/SDSU in Clinical Psychology
                    specializing in Behavioral Medicine.  In addition to her work counseling
                    individual and couples, Kiandra teaches classes centered around
                    cognitive behavioral therapy and mindfulness. She helps clients
                    develop more flexible perspectives and philosophies about life,
                    improved connectedness, and greater consciousness through learning
                    mindfulness, self acceptance, emotional regulation, and cognitive therapy.
                    Kiandra has been influenced by her interest in yoga,
                    meditation, lucid dreaming, and study of eastern philosophy.
                  </p>
                </div>
              </div>
            </div>
        );
    }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/About.js
 **/